// Keeps file references known but invisible until attachment presentation
// enters the V3 scope.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const fileRefPayloadSchema = z
    .object({
        file_url: z.string(),
        filename: z.string(),
    })
    .strip();

export const fileRefDefinitions = {
    file_ref: defineInvisible('file_ref', {
        disposition: 'invisible',
        schema: fileRefPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const fileRefContractFixtures = {
    valid: {
        file_url: 'https://example.invalid/report.pdf',
        filename: 'report.pdf',
    },
    malformed: {
        file_url: 'https://example.invalid/report.pdf',
        filename: 7,
    },
} as const;
